<aside
  id="sidebar"
  class="fixed top-0 left-0 z-20 flex-col flex-shrink-0 hidden w-64 h-full pt-32 font-normal duration-75 lg:flex transition-width"
  aria-label="Sidebar"
  *ngIf="user$ | async as user"
>
  <div
    class="relative flex flex-col flex-1 min-h-0 pt-0 bg-sidenav border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700"
  >
    <div
      class="flex flex-col flex-1 pt-5 pb-4 overflow-y-auto overflow-x-hidden"
    >
      <div
        class="flex-1 px-3 space-y-1 bg-sidenav divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700"
      >
        <ul class="pb-2 space-y-2">
          <li>
            <form action="#" method="GET" class="lg:hidden">
              <label for="mobile-search" class="sr-only">Search</label>
              <div class="relative">
                <div
                  class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                >
                  <svg
                    class="w-5 h-5 text-gray-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </div>
                <input
                  type="text"
                  name="email"
                  id="mobile-search"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-200 dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Search"
                />
              </div>
            </form>
          </li>

          <li>
            <a
              [href]="routes[user.role]"
              [routerLink]="routes[user.role]"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="chart-pie-slice"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Общ преглед</span
              >
            </a>
          </li>
          <li *ngIf="user.role === 'administrator'">
            <a
              href="/admin-panel/accounts"
              routerLink="/admin-panel/accounts"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="people-multiple"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Акаунти</span
              >
            </a>
          </li>

          <li>
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-clicnics"
              data-collapse-toggle="dropdown-clicnics"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="building"
              ></icon-wrap>

              <span class="flex-1 ml-3 text-left whitespace-nowrap"
                >Клиники</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-clicnics" class="space-y-2 py-2 hidden">
              <li *ngIf="canAddClinic">
                <a
                  routerLink="/admin-panel/clinics/ADD"
                  href="/admin-panel/clinics/ADD"
                  [replaceUrl]="true"
                  routerLinkActive="bg-gray-100"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Добави клиника</span>
                </a>
              </li>
              <li *ngFor="let clinic of userClinics">
                <a
                  [routerLink]="['/admin-panel/clinics', clinic._id]"
                  [replaceUrl]="true"
                  [href]="'/admin-panel/clinics/' + clinic._id"
                  routerLinkActive="bg-gray-100"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">{{ clinic.name }}</span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-patients"
              data-collapse-toggle="dropdown-patients"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="animal-footprint"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Пациенти</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-patients" class="space-y-2 py-2 hidden">
              <li>
                <a
                  routerLink="/admin-panel/patients"
                  routerLinkActive="bg-gray-100"
                  [routerLinkActiveOptions]="{ exact: true }"
                  href="/admin-panel/patients"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с пациенти</span>
                </a>
              </li>

              <!-- <li>
                <a
                  routerLink="/admin-panel/patients/ADD"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/patients/ADD"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Добави пациент</span>
                </a>
              </li> -->
            </ul>
          </li>
          <li>
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-employees"
              data-collapse-toggle="dropdown-employees"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="stethoscope"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Служители</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-employees" class="space-y-2 py-2 hidden">
              <li>
                <a
                  [routerLink]="['employees', user.activeClinic]"
                  routerLinkActive="bg-gray-100"
                  [href]="'employees/' + user.activeClinic"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък със служители</span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-sales"
              data-collapse-toggle="dropdown-sales"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="shopping-bag-paw"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Продажби</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-sales" class="space-y-2 py-2 hidden">
              <li
                (click)="hasActiveClinic()"
                [ngClass]="{
                  'opacity-50': !user.activeClinic
                }"
              >
                <a
                  [ngClass]="{
                    'pointer-events-none': !user.activeClinic
                  }"
                  routerLinkActive="bg-gray-100"
                  [routerLink]="
                    '/admin-panel/stocks/' + user.activeClinic + '/sales'
                  "
                  [href]="'/admin-panel/stocks/' + user.activeClinic + '/sales'"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с продажби</span>
                </a>
              </li>
              <li
                (click)="hasActiveClinic()"
                [ngClass]="{
                  'opacity-50': !user.activeClinic
                }"
              >
                <a
                  [ngClass]="{
                    'pointer-events-none': !user.activeClinic
                  }"
                  routerLinkActive="bg-gray-100"
                  [routerLink]="
                    '/admin-panel/stocks/' + user.activeClinic + '/services'
                  "
                  [href]="
                    '/admin-panel/stocks/' + user.activeClinic + '/services'
                  "
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с услуги</span>
                </a>
              </li>

              <li
                (click)="hasActiveClinic()"
                [ngClass]="{
                  'opacity-50': !user.activeClinic
                }"
              >
                <a
                  [ngClass]="{
                    'pointer-events-none': !user.activeClinic
                  }"
                  routerLinkActive="bg-gray-100"
                  [routerLink]="
                    '/admin-panel/stocks/' + user.activeClinic + '/products'
                  "
                  [href]="
                    '/admin-panel/stocks/' + user.activeClinic + '/products'
                  "
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с продукти</span>
                </a>
              </li>
              <li
                (click)="hasActiveClinic()"
                [ngClass]="{
                  'opacity-50': !user.activeClinic
                }"
              >
                <a
                  [ngClass]="{
                    'pointer-events-none': !user.activeClinic
                  }"
                  routerLinkActive="bg-gray-100"
                  [routerLink]="
                    '/admin-panel/stocks/' +
                    user.activeClinic +
                    '/food-supplements'
                  "
                  [href]="
                    '/admin-panel/stocks/' +
                    user.activeClinic +
                    '/food-supplements'
                  "
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с хр. добавки</span>
                </a>
              </li>
              <li
                (click)="hasActiveClinic()"
                [ngClass]="{
                  'opacity-50': !user.activeClinic
                }"
              >
                <a
                  [ngClass]="{
                    'pointer-events-none': !user.activeClinic
                  }"
                  routerLinkActive="bg-gray-100"
                  [routerLink]="
                    '/admin-panel/stocks/' + user.activeClinic + '/accessories'
                  "
                  [href]="
                    '/admin-panel/stocks/' + user.activeClinic + '/accessories'
                  "
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с аксесоари</span>
                </a>
              </li>
              <!-- <li>
                <a
                  routerLink="/admin-panel/employees"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/employees"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Добави продукт или услуга</span>
                </a>
              </li> -->
            </ul>
          </li>
          <li>
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-owners"
              data-collapse-toggle="dropdown-owners"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="people-multiple"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Стопани</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-owners" class="space-y-2 py-2 hidden">
              <li>
                <a
                  routerLink="/admin-panel/pet-owners"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/pet-owners"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък със стопани</span>
                </a>
              </li>

              <!--   <li>
                <a
                  routerLink="/admin-panel/employees"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/employees"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Добави нов стопанин</span>
                </a>
              </li> -->
            </ul>
          </li>
          <li class="pointer-events-none opacity-50">
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="calendar"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >График на служителите</span
              >
            </button>
          </li>
          <li class="pointer-events-none opacity-50">
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-booked-hours"
              data-collapse-toggle="dropdown-booked-hours"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="clock"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Записани часове</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-booked-hours" class="space-y-2 py-2 hidden">
              <li>
                <a
                  routerLink="/admin-panel/booked-hours"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/booked-hours"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Списък с записани часове</span>
                </a>
              </li>

              <!--  <li>
                <a
                  routerLink="/admin-panel/employees"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/employees"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Добави час</span>
                </a>
              </li> -->
            </ul>
          </li>
          <li class="pointer-events-none opacity-50">
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:fill-white hover:text-white hover:bg-orange-100 dark:text-gray-200 dark:hover:bg-gray-700"
              aria-controls="dropdown-settings"
              data-collapse-toggle="dropdown-settings"
            >
              <icon-wrap
                class="w-6 h-6 flex justify-center items-center"
                name="gear"
              ></icon-wrap>

              <span
                class="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item=""
                >Настройки</span
              >
              <img src="assets/svgs/caret-down.svg" class="w-6 h-6" />
            </button>
            <ul id="dropdown-settings" class="space-y-2 py-2 hidden">
              <li>
                <a
                  routerLink="/admin-panel/patients"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/patients"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Настройки на профила</span>
                </a>
              </li>

              <li>
                <a
                  routerLink="/admin-panel/employees"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/employees"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Сигурност</span>
                </a>
              </li>
              <li>
                <a
                  routerLink="/admin-panel/employees"
                  routerLinkActive="bg-gray-100"
                  href="/admin-panel/employees"
                  class="text-base text-gray-900 rounded-lg flex items-center p-2 group hover:bg-gray-300 transition duration-75 pl-11 dark:text-gray-200 dark:hover:bg-gray-700"
                >
                  <span class="ml-3">Промяна на цветове</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</aside>
